export default {
  MOBILE: '@media (max-width: 749px)',
  SMALL_DESKTOP: '@media (min-width: 750px)',
};
